<template>
  <div>
    <h2 class="text-lg font-semibold">Modifier le Challenge</h2>
    <div class="mt-4 mb-6">
      <Selector
        id="rewardStatus"
        name="rewardStatus"
        label="Statut des gains"
        :required="true"
        v-model="formData.rewardStatus"
        :options="rewardStatusOptions"
      />
    </div>
    <GenericButton @click="updateChallenge">Modifier</GenericButton>
  </div>
</template>
<script>
import { GenericButton, Selector } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: {
    GenericButton,
    Selector,
  },
  emits: ["success"],
  props: {
    challenge: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        rewardStatus: this.challenge.rewardStatus,
      },
      rewardStatusOptions: [
        { value: "pending", label: "En attente" },
        { value: "sent", label: "Envoyé" },
        { value: "activated", label: "Activé" },
      ],
    };
  },
  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("challenges", ["update"]),
    async updateChallenge() {
      if (!confirm("Modifier le statut des gains va envoyer des mails aux participants. Continuer ?")) return;

      const { success } = await this.update({ challengeId: this.challenge.id, payload: this.formData });
      if (success) {
        await this.notify({
          category: "simple",
          type: "success",
          title: "Challenge mis à jour",
        });
        this.$emit("success");
      } else {
        this.notify({
          category: "simple",
          type: "error",
          title: "Erreur lors de la mise à jour",
        });
      }
    },
  },
};
</script>
